/* global axios */
import ApiClient from '../ApiClient';

const extractResponseError = error => {
  const data = error?.response?.data;

  if (data?.error) return data.error;
  if (data?.message) return data.message;
  if (typeof data === 'string' && data.trim()) {
    return data
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 180);
  }

  return error?.message || 'Request failed';
};

class WhatsappFreeChannelAPI extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  async createInbox({ name }) {
    const response = await axios.post(`${this.url}/inboxes`, { name });
    return response.data;
  }

  async setupQr(setupId) {
    const response = await axios.get(`${this.url}/setups/${setupId}/qr`);
    return response.data;
  }

  async setupReconnect(setupId) {
    const response = await axios.post(`${this.url}/setups/${setupId}/reconnect`);
    return response.data;
  }

  async setupFinalize(setupId) {
    const response = await axios.post(`${this.url}/setups/${setupId}/finalize`);
    return response.data;
  }

  async setupDestroy(setupId) {
    const response = await axios.delete(`${this.url}/setups/${setupId}`);
    return response.data;
  }

  async showInbox(inboxId) {
    const response = await axios.get(`${this.url}/inboxes/${inboxId}`);
    return response.data;
  }

  async inboxQr(inboxId) {
    const response = await axios.get(`${this.url}/inboxes/${inboxId}/qr`);
    return response.data;
  }

  async inboxReconnect(inboxId) {
    const response = await axios.post(`${this.url}/inboxes/${inboxId}/reconnect`);
    return response.data;
  }

  async inboxDisconnect(inboxId) {
    const response = await axios.delete(`${this.url}/inboxes/${inboxId}/session`);
    return response.data;
  }
}

export { extractResponseError };
export default new WhatsappFreeChannelAPI();
